<template>
    <div class="row">
        <div class="col-12">
            <div class="list-group-item align-items-center">
                <div class="row">
                    <div class="col-10"> 
                        <div class="form-inline gap-2">
                            <template v-for="(options,x) in getOptions">
                                <SelectInput
                                    :key="x"
                                    v-if="displayInput(x) && getOptions[0].length > 0"
                                    :disabled="displayInput(x+2)"
                                    v-model="node_query[x]"
                                    :nullable="true"
                                    :nullLabel="x == 0 ? $t('curriculum') : $t('child-n',{n : x})"
                                    :options="options"
                                    :label="x == 0 ? $t('curriculum') : $t('child-n',{n : x})"
                                    :srOnly="true"
                                    class="select-input"
                                    @input="$emit('filtered-nodes', filteredNodes)"
                                />
                            </template>
                            <TextInput
                                v-if="(getOptions.length > 1 || outmost_query) && view === 'component'"
                                v-model="outmost_query"
                                :nullable="true"
                                :nullLabel="$t('search')"
                                :label="$t('search')"
                                :srOnly="true"
                                class="search-input"
                                @input="$emit('filtered-nodes', filteredNodes)"
                            />
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="float-right d-flex align-items-center flex-nowrap">
                            <div class="btn-group">
                                <button 
                                    v-if="view === 'search'"
                                    :disabled="node_query.filter(x => x !== null).length == 0" 
                                    class="btn btn-primary btn-md" 
                                    @click="$router.push(`/curriculum-mapping/node/${filteredNodes[0].id}/graph`)">
                                    {{ $t('go') }} 
                                </button>
                                <button 
                                    v-if="node_query.length>0"
                                    :disabled="node_query.filter(x => x !== null).length == 0" 
                                    class="btn btn-secondary btn-md" 
                                    @click="node_query = [null]; hydrateNodeQuery(); $emit('filtered-nodes', filteredNodes)">
                                    {{ $t('clear') }} 
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    
export default {
    components: {

    },
    props: {
        view: {
            type: String,
            default: () => ''
        },
        selectedNode:{
            type: Object,
            default: () => {}
        },
        availableNodes: {
            type: Array,
            default: null
        }
    },
    watch: {
        maxPath(newValue) {
            this.resetNodeQuery(newValue);
        },
        filteredNodes(newValue) {
            this.hydrateNodeQuery(newValue);
        },
        // node_query(newValue, oldValue) {
        //     const oldHasQuery = oldValue.filter(x => x !== null).length > 0
        //     const newHasQuery = newValue.filter(x => x !== null).length > 0

        //     if (oldHasQuery !== newHasQuery) {
        //         this.$emit('hasQuery', newHasQuery)
        //     }
        // }
        node_query: {
            handler(newValue) {
                const hasQuery = newValue.filter(x => x !== null).length > 0;
                this.$emit('hasQuery', hasQuery);
                this.hydrateNodeQuery(newValue);
            },
            deep: true,
            immediate: true
        },
    },
    data() {
        return {
            node_query:[null],
            outmost_query: null,
            nodes: []
        };
    },
    mounted(){
        if (!this.availableNodes) this.getNodes();
        this.$emit('hasQuery', this.node_query.filter(x => x !== null).length > 0);
    },
    methods: {
        displayInput(index){
            if (index == 0) {// Always render the first SelectInput
                return true;
            } else {// Render if the previous v-model is non-empty
                return !!this.node_query[index - 1] && this.displayInput(index - 1);
            }
        },
        hydrateNodeQuery(){
            const index = this.node_query.findIndex(str => !str);
            if (index !== -1) {
                for (let i = index + 1; i < this.node_query.length; i++) {
                    this.node_query[i] = null;
                }
            }
        },
        resetNodeQuery(){
            for (let i = 0; i < this.maxPath; i++) {
                this.node_query.push(null);
            }
        },
        getNodes(){
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/listnodes`, {
                method: 'post',
                data: {
                    string: true,
                    all_nodes: false
                }
            })
            .then((res) => {
                if (res.status === "SUCCESS") {
                    if(res.results) this.nodes = res.results;
                }
            });
        },
    },
    computed: {
        nodeSource() {
            return this.availableNodes !== null ? this.availableNodes : this.nodes;
        },
        nodesForSelects() {
            // Same as filteredNodes but ignores outmost_query so the select dropdowns
            // stay visible even when the text search returns no results.
            const node_query = this.node_query.filter(z => z !== null);
            if (node_query.length === 0) return this.nodeSource;

            const arrMatch = (path, query) => {
                path = path.map(x => x.toLowerCase().trim());
                query = query.map(x => x.toLowerCase().trim());
                if (path.length < query.length) return false;
                for (let i = 0; i < query.length; i++) {
                    if (path[i] !== query[i]) return false;
                }
                return true;
            };

            return this.nodeSource.filter(node => arrMatch(node.path.split('>'), node_query));
        },
        maxPath() {
            let max = 0;
            for (let obj of this.nodesForSelects) {
                const offset = ['search', 'transmute'].includes(this.view) ? 0 : 1;

                const vertex = obj.path.split('>').length - offset;
                if (vertex > max) max = vertex;
            }
            return max;
        },
        getOptions() {
            let child ={}
            for (let i=0; i<=this.maxPath; i++){
                child[i]=new Set();
            }

            for (let obj of this.nodesForSelects) {
                let string = obj.path.split('>');
                if(string.length>1){
                    
                   const offset = ['search', 'transmute'].includes(this.view) ? 0 : 1;

                    for(let i=0; i<=string.length-offset; i++){
                        if(string[i]) child[i].add(string[i]);
                    }
                } else {
                    child[0].add(string[0])
                }

            }

            let result =[];
            for(let i=0; i<=this.maxPath; i++) {
                result.push(Array.from(child[i]));
            }

            // If an entry is empty, then it stops at the previous member
            if(this.maxPath>1){
                const index = result.findIndex(str => !str);
                result = result.slice(0, index);
            }

            // Check if it is totally empty
            if(
                this.maxPath > 1 
                && 
                result.every(subArr => Array.isArray(subArr) && subArr.length === 0)
            ){
                result = []
            }

            return result;
        },
        filteredNodes(){
            /*
                Exclude null entries, bear in mind that node_query DOES NOT contain the search from
                the TextInput
            */
            let node_query = this.node_query.filter(z => z !== null);

            if(node_query || this.outmost_query){

                // Check if the two arrays, path and query, match item-wise
                const arrMatch = (path, query)=> {
                    path = path.map(x => x.toLowerCase().trim() )
                    query= query.map(x => x.toLowerCase().trim() )

                    if (path.length < query.length) return false;

                    for (let i = 0; i < query.length; i++) {
                        if (path[i] !== query[i]) return false;
                    }
                    return true;
                }

                // Check if the last item in a path contains the query from the TextInput
                const strMatch = (path,query) => {
                    return path[path.length-1].toLowerCase().trim().includes(query.toLowerCase().trim());
                }

                let result = this.nodeSource.filter(node => {
                    const path = node.path.split('>');
                    if (this.outmost_query) {
                        if (node_query.length > 0) {
                            return arrMatch(path, node_query) && strMatch(path, this.outmost_query);
                        } else {
                            return strMatch(path, this.outmost_query);
                        }
                    } else {
                        return node_query.length > 0 ? arrMatch(path, node_query) : true;
                    }
                });

                return result;

            }

            return this.nodeSource;
        }
    }
};
</script>
<style scoped>
/* Base styles */
.form-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  width: 100%;
}

/* SelectInput container */
.select-input {
  flex: 0 1 auto; /* Don't grow, but can shrink */
  min-width: 150px;
  max-width: 200px;
  position: relative;
}

/* Force text truncation in SelectInput */
.select-input ::v-deep .form-control {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
  min-width: 0; /* Crucial for flex children truncation */
}

/* Search input styling */
.search-input {
  flex: 1 1 250px;
  min-width: 180px;
}

/* Responsive behavior */
@media (max-width: 768px) {
  .form-inline {
    gap: 12px;
  }
  
  .select-input {
    flex-basis: calc(50% - 6px);
    max-width: calc(50% - 6px);
  }
}

@media (max-width: 500px) {
  .form-inline {
    flex-direction: column !important;
    gap: 8px !important;
  }

  .select-input,
  .search-input {
    width: 100% !important;
    min-width: 0 !important; /* Allow elements to shrink below 120px */
    max-width: 100px !important;
    flex-basis: 100% !important;
  }

  /* Force ellipsis on direct child elements */
  .select-input ::v-deep .form-control {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    min-width: 0 !important;
    max-width: 100% !important;
  }

  /* Optional: Add context for truncated text */
  .select-input ::v-deep .form-control {
    position: relative;
  }
  .select-input ::v-deep .form-control:hover::after {
    content: attr(title);
    position: absolute;
    background: white;
    border: 1px solid #ddd;
    padding: 4px;
    z-index: 1000;
    top: 100%;
    left: 0;
  }
}

/* Special handling for 4+ inputs */
@media (min-width: 1200px) {
  .select-input {
    flex-basis: calc(25% - 8px); /* 4 per row */
    max-width: calc(25% - 8px);
  }
}

/* Fallback for very wide screens */
@media (min-width: 1600px) {
  /* .form-inline {
    flex-wrap: nowrap;
  } */
  .select-input {
    flex-basis: auto;
    max-width: 220px;
  }
}
</style>